import apiOffice from "../axios/apiOffice";

class StatisticsService {
  static async byType(body = {}) {
    try {
      const response = await apiOffice.post(`/statistics/`, body);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error getting tags:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default StatisticsService;
